import { definePreset } from "@primeng/themes";
import Nora from "@primeng/themes/nora";
import { checkbox } from "./checkbox";

export const Liga = definePreset(Nora, {
  components: {
    checkbox,
  }
});
